import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=b72ae8ac&scoped=true&"
import script from "./CategoryItem.vue?vue&type=script&lang=ts&"
export * from "./CategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryItem.vue?vue&type=style&index=0&id=b72ae8ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ae8ac",
  null
  
)

export default component.exports